import { StyledWrapper } from './style';
import Button from '../../../../components/Button';
import toast from 'react-hot-toast';

interface DeleteConfirmToastProps {
  onDelete: () => void;
}
export function DeleteConfirmToast({ onDelete }: DeleteConfirmToastProps) {
  return (
    <StyledWrapper id="delete-confirm-toast">
      <p className="title" id="delete-confirm-toast-title">
        Delete row
      </p>
      <p className="text" id="delete-confirm-toast-text">
        Are you sure you want to delete this row? <br /> This row contains data.
      </p>
      <div className="footer" id="delete-confirm-toast-footer">
        <div id="delete-confirm-toast-footer-spacer" />
        <div className="buttons" id="delete-confirm-toast-buttons">
          <Button
            id="delete-confirm-toast-cancel-button"
            size="sm"
            onClick={() => toast.remove()}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button id="delete-confirm-toast-delete-button" onClick={onDelete} size="sm">
            Yes, Delete Row
          </Button>
        </div>
      </div>
    </StyledWrapper>
  );
}
